import { useEffect, useRef, useState } from "react";

export function ExtraInfoIcon({ extraInfo }: { extraInfo: string }) {
  const [open, setOpen] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [open]);

  return (
    <span className="relative inline-flex" ref={popoverRef}>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
        className="flex-shrink-0 w-5 h-5 rounded-full bg-white/20 text-white/70 hover:bg-white/30 hover:text-white text-xs font-medium flex items-center justify-center transition-colors"
        aria-label="More info"
        title={extraInfo}
      >
        ?
      </button>
      {open && (
        <div
          className="absolute bottom-full left-0 mb-1.5 z-10 min-w-[180px] max-w-[260px] py-2 px-3 rounded-lg bg-white/10 border border-white/20 text-white/90 text-xs shadow-lg"
          role="tooltip"
        >
          {extraInfo}
        </div>
      )}
    </span>
  );
}
